<template>
  <!-- <transition name="fade" appear> -->
  <div v-show="shown" :class="$style.toast" :style="$store.state.event.themeStyles">
    <span :class="$style.closeButton">
      <SvgIcon name="cross" color="primary-text-color" @click="close" />
    </span>
    <span :class="$style.toastHeader">
      <span v-if="icon" :class="$style.toastIcon">
        <SvgIcon :name="icon" color="theme-secondary-color" />
      </span>
      <StyledText color="theme-secondary-color" variant="heading14">
        {{ title }}
      </StyledText>
    </span>
    <div :class="$style.toastBody">
      <StyledText color="primary-text-color">
        <span ref="messager" :class="$style.messages" />
      </StyledText>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import { SvgIcon } from 'uicomponents';
export default {
  name: 'Toast',
  components: { SvgIcon },
  props: {
    title: String,
    message: String,
    type: {
      type: String,
      default: 'success'
    },
    icon: String,
    duration: Number,
    variables: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      shown: false
    };
  },
  mounted() {
    setTimeout(() => (this.shown = true), 300);
    if (this.duration) {
      setTimeout(() => {
        this.close();
      }, this.duration);
    }
    this.mountFormattedMessage();
  },
  methods: {
    close() {
      this.shown = false;
      setTimeout(() => {
        this.$emit('cancel');
      }, 300);
    },
    mountFormattedMessage() {
      // Create nodes to mount in toast message
      const documentNodes = this.message.split('*').map((subMessage, index) => {
        const variable = index % 2 === 1 && this.variables[(index - 1) / 2]; // indexing starts with 0, and every second index is a variable
        const textNode = document.createTextNode(subMessage);
        if (variable) {
          if (variable.type === 'link') {
            const anchor = document.createElement('a');
            anchor.href = variable.value;
            anchor.target = '_blank';
            anchor.appendChild(textNode);
            return anchor;
          }
        }
        return textNode;
      });

      // Mount nodes in toast message
      documentNodes.map(elem => {
        this.$refs.messager.appendChild(elem);
      });
    }
  }
};
</script>

<style lang="css" module>
.toast {
  background-color: var(--theme-primary-color);
  border-radius: 16px;
  position: relative;
  margin: 16px 0 0;
  padding: 16px;
}

.toastHeader {
  font-size: 13px;
  line-height: 13px;
  font-weight: 700 !important;
  display: flex;
  align-items: center;
  margin: 0 0 8px;
}

.toastIcon {
  margin-right: 8px;
}

.closeButton {
  position: absolute;
  right: 8px;
  top: 8px;
  font-weight: bold;
  cursor: pointer;
}

.toastBody {
  font-size: 14px;
  line-height: 14px;
  font-weight: 500 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.messages a {
  color: var(--theme-secondary-color) !important;
}
</style>
